import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { withRouter } from 'react-router'

import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Layout from '../../../../components/ui/Layout/Layout'

import validateOtp from '../../../../services/validation/OTP'
import OtpForm from '../../../../components/home/OtpForm/OtpForm'
import OtpResendForm from '../../../../components/home/OtpResendForm/OtpResendForm'

import { setGAPageView } from '../../../../services/analytics/google-analytics'
import media from '../../../../services/generateMediaQueries'
import { getAccessToken } from '../../../../services/data/accessToken'

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  font-weight: var(--font-weight-boldest);
  color: var(--color-secondary);
`

const Description = styled.p`
  text-align: center;
`

const FormWrapper = styled.div`
  margin: 2.5rem 0;
  margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? 0 : '2.5rem')};
  ${media.lessThan('small')`
    margin: 1.5rem 0;
    margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? 0 : '1.5rem')};
  `};
`

const PermissionLabel = styled.div`
  text-align: center;
  font-size: 0.875rem;
  margin: 1rem 0;
`

const MainView = props => {
  const {
    replace,
    location,
    maskedData,
    accessToken,
    doVerifyOtp,
    otpToMobile,
    doRequestOtp,
    deleteRequestId,
    setDeleteRequestId,
    setDeleteMaskedData,
    setDeleteOtpToMobile,
  } = props

  const checkToken = async () => {
    // redirect if no token found
    const cookieToken = await getAccessToken()
    if (!accessToken || !cookieToken) {
      replace('/')
    }
    if (!deleteRequestId) {
      replace('/delete-account')
    }
  }

  const getDescription = maskedData => {
    const { lastFourDigits, maskedEmail } = maskedData || {}
    return otpToMobile
      ? `You will receive a One-Time-PIN (OTP) on your registered mobile number ending ${lastFourDigits}`
      : `You will receive a One-Time PIN (OTP) on your registered email address ${maskedEmail}`
  }

  const handleResendOtp = async (values, state) => {
    const { setSubmitting, setStatus } = state
    setSubmitting(true)
    const { toMobile } = values
    setDeleteOtpToMobile(toMobile)
    // setGAEvent('button_cta', 'Delete Account - OTP Verification', 'Resend OTP ')

    try {
      await doRequestOtp({
        toMobile,
        setStatus,
        accessToken,
        setDeleteRequestId,
        setDeleteMaskedData,
      })
    } catch (error) {
      const { status } = error.response || {}

      state.setStatus({
        status,
        error,
      })
    }
    setSubmitting(false)
  }

  React.useState(() => {
    setGAPageView(location.pathname)
    checkToken()
  }, [])

  return (
    <Layout>
      <Title>Verify mobile number</Title>
      <Description>{getDescription(maskedData)}</Description>
      <FormWrapper>
        <AccessibleForm
          initialValues={{}}
          validate={validateOtp}
          onSubmit={doVerifyOtp({ replace, accessToken, deleteRequestId })}
          component={OtpForm}
          action="/a/otp/submit"
          method="post"
        />
      </FormWrapper>
      <PermissionLabel>
        <AccessibleForm
          initialValues={{}}
          onSubmit={handleResendOtp}
          component={props => (
            <OtpResendForm smsMode={otpToMobile} loginResend {...props} />
          )}
          action="/a/otp/resend"
          method="post"
        />
      </PermissionLabel>
    </Layout>
  )
}

MainView.defaultProps = {
  replace: null,
}

MainView.propTypes = {
  push: PropTypes.func,
}

export default withRouter(MainView)
